//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, pageExport } from '@/apis/member'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [
                    {
                        id: 1, name: "啟用",

                    },
                    {
                        id: 2, name: "停用",
                    }
                ],
            },
            searchQuery: {
                serialNo: '',
                exp: 0,
                phone: "",
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '編號', dataIndex: 'serial_no', key: 'serial_no', width: 150 },
            { title: '姓名', dataIndex: 'name', key: 'name', width: 150 },
            { title: '信箱', dataIndex: 'email', key: 'email', width: 260 },
            { title: '手機', dataIndex: 'phone', key: 'phone', width: 150 },
            { title: '生日', dataIndex: 'birthday', key: 'birthday', width: 150 },
            { title: '性別', dataIndex: 'gender_text', key: 'gender', width: 150 },
            { title: '剩餘紅利點數', dataIndex: 'balance', key: 'balance', width: 150 },
            { title: '標籤', dataIndex: 'tags', key: 'tags', width: 150 },
            { title: '備註', dataIndex: 'remark', key: 'remark', width: 150 },
            { title: '電話', dataIndex: 'tel', key: 'tel', width: 150 },
            { title: '公司', dataIndex: 'company_name', key: 'company_name', width: 150 },
            { title: '郵遞區號', dataIndex: 'zipcode', key: 'zipcode', width: 150 },
            { title: '地址', dataIndex: 'address', key: 'address', width: 150 },
            { title: '下單次數', dataIndex: 'order_total', key: 'order_total', width: 150 },
            { title: '消費總額', dataIndex: 'order_amount', key: 'order_amount', width: 150 },
            { title: '加入日期', dataIndex: 'joined_at', key: 'joined_at', width: 180 },
            { title: '註冊來源', dataIndex: 'source', key: 'source', width: 150 },
            { title: 'uid', dataIndex: 'uid', key: 'uid', width: 150 },
            { title: '狀態', dataIndex: 'status_text', key: 'status_text', width: 150 },
            { title: '註冊人分潤代碼', dataIndex: 'invite_code', key: 'invite_code', width: 150 },
            { title: '最新訂單日期', dataIndex: 'last_order_at', key: 'last_order_at', width: 180 },
            { title: '是否訂閱商家優惠', dataIndex: 'is_subscribe', key: 'is_subscribe', width: 150, scopedSlots: { customRender: 'enumSlot' } },
            { title: '是否允許超商取貨', dataIndex: 'is_super_market', key: 'is_super_market', width: 150, scopedSlots: { customRender: 'enumSlot' } },
            { title: '創建時間', dataIndex: 'created_at', key: 'created_at', width: 180, },
            { title: '最後更新時間', dataIndex: 'updated_at', key: 'updated_at', width: 180, },
            // { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            // await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageConfig() {
            try {

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    page: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },


        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.searchQuery.exp = 0;
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            this.searchQuery.exp = 0;
            e.preventDefault();
            this.onPageLoad();
        },
        handleToAdd(id) {
            if (id > 0) {
                this.$router.push(`/member/edit/${id}`);
            } else {
                this.$router.push('/member/add');
            }
        },
        handleToExport() {
            this.searchQuery.exp = 1;
            this.onPageExport();
        },
        async onPageExport() {
            try {
                this.loading = true;
                const response = await pageExport({
                    ...this.searchQuery
                });

                // 創建下載鏈接
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `member_${moment().format('MMDDss')}.xlsx`); // 設置文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        }
    }
}
